import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography, Switch, Divider, Radio, Space } from 'antd';
import { useUserInfo } from 'hooks';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/member-profile';
import { CustomNotification, EditButton, FormSaveButton, FormCancelButton } from 'common/components';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import * as memberServices from 'services/members';
import './style.less';

const { Title } = Typography;


const QaSpecTemplateManagementSupplier = (props) => {
  const { memberInfo, hasPermissionEdit, mode, supplierId, onSettingsChange, initialSettings } = props;
  const { userInfo } = useUserInfo();
  const { id } = useParams();

  const ownerIdValue = id ? id : userInfo?.companyId;

  const [loading, setLoading] = useState(false);
  const [checkedQaSpecVisibility, setCheckedQaSpecVisibility] = useState(false);
  const [selectedDownloadOption, setSelectedDownloadOption] = useState(null);
  const [selectedUploadOption, setSelectedUploadOption] = useState(null);
  const [qaSpecSettings, setQaSpecSettings] = useState({
    isQASpecTemplateVisibility: null,
    isQASpecTemplateDownloadWithData: null,
    isQASpecTemplateUploadOverrideData: null
  });
  const [isEditMode, setIsEditMode] = useState(false);

  // const notifyParent = (params) => {
  //   if (typeof onSettingsChange === 'function') {
  //     onSettingsChange(params);
  //   }
  // };

  const onDownloadOptionChange = (e) => {
    const value = e.target.value;
    setSelectedDownloadOption(value);

    // if (selectedUploadOption == null) {
    //   // no API call; parent can decide how to handle validation
    //   return;
    // }

    // if (value) {
    //   const params = {
    //     memberId: mode == 'supplier' ? supplierId : memberInfo?.id,
    //     ownerId: ownerId,
    //     isQASpecTemplateVisibility: checkedQaSpecVisibility,
    //     isQASpecTemplateDownloadWithData: value === 'with-data',
    //     isQASpecTemplateUploadOverrideData: selectedUploadOption === 'overwrite-data',
    //     mode: mode
    //   };
    //   notifyParent(params);
    // }
  };

  const onUploadOptionChange = (e) => {
    const value = e.target.value;
    setSelectedUploadOption(value);

    // if (selectedDownloadOption == null) {
    //   return;
    // }

    // if (value) {
    //   const params = {
    //     memberId: mode == 'supplier' ? supplierId : memberInfo?.id,
    //     ownerId: ownerId,
    //     isQASpecTemplateVisibility: checkedQaSpecVisibility,
    //     isQASpecTemplateUploadOverrideData: value === 'overwrite-data',
    //     isQASpecTemplateDownloadWithData: selectedDownloadOption === 'with-data',
    //     mode: mode
    //   };
    //   notifyParent(params);
    // }
  };

  const onSwitchQaSpecVisibility = (checked) => {
    setCheckedQaSpecVisibility(checked);
    // const params = {
    //   memberId: mode == 'supplier' ? supplierId : memberInfo?.id,
    //   ownerId: ownerId,
    //   isQASpecTemplateVisibility: checked,
    //   mode: mode
    // };
    // notifyParent(params);
  };

  // populate state when parent provides initial settings
  useEffect(() => {
    if (initialSettings) {
      setQaSpecSettings(initialSettings);
      setCheckedQaSpecVisibility(initialSettings.isQASpecTemplateVisibility || false);

      if (initialSettings.isQASpecTemplateDownloadWithData === true) {
        setSelectedDownloadOption('with-data');
      } else if (initialSettings.isQASpecTemplateDownloadWithData === false) {
        setSelectedDownloadOption('without-data');
      } else {
        setSelectedDownloadOption(null);
      }

      if (initialSettings.isQASpecTemplateUploadOverrideData === true) {
        setSelectedUploadOption('overwrite-data');
      } else if (initialSettings.isQASpecTemplateUploadOverrideData === false) {
        setSelectedUploadOption('update-data');
      } else {
        setSelectedUploadOption(null);
      }
    }
  }, [initialSettings, memberInfo]);

  const fetchQaSpecSettings = async () => {
    const params = {
      memberId: mode == 'supplier' ? supplierId : memberInfo?.id,
      ownerId: ownerId,
      mode: mode
    }

    var result = await memberServices.getQaSpecTemplateSettings(params);

    setQaSpecSettings(result?.data)
    setCheckedQaSpecVisibility(result?.data?.isQASpecTemplateVisibility || false);

    if (result?.data?.isQASpecTemplateDownloadWithData === true) {
      setSelectedDownloadOption('with-data');
    } else if (result?.data?.isQASpecTemplateDownloadWithData === false) {
      setSelectedDownloadOption('without-data');
    } else {
      setSelectedDownloadOption(null);
    }

    if (result?.data?.isQASpecTemplateUploadOverrideData === true) {
      setSelectedUploadOption('overwrite-data');
    } else if (result?.data?.isQASpecTemplateUploadOverrideData === false) {
      setSelectedUploadOption('update-data');
    } 
    // else {
    //   if (memberInfo?.memberName == "Dollar General" && result?.data?.isQASpecTemplateUploadOverrideData === null) {
    //     setSelectedUploadOption('update-data');
    //   } else {
    //     setSelectedUploadOption(null);
    //   }
    // }
  }

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleCancel = () => {
    setIsEditMode(false);
  };

  const handleSave = () => {
    setLoading(true);

    if (selectedDownloadOption == null || selectedUploadOption == null) {
      CustomNotification.error("Please select both download and upload options before saving.");
      setLoading(false);
      return;
    }

    if (!ownerIdValue) {
      CustomNotification.error("Owner ID is required.");
      setLoading(false);
      return;
    }

    const params = {
      memberId: mode == 'supplier' ? supplierId : memberInfo?.id,
      ownerId: parseInt(ownerIdValue),
      isQASpecTemplateVisibility: checkedQaSpecVisibility,
      isQASpecTemplateUploadOverrideData: selectedUploadOption === 'overwrite-data',
      isQASpecTemplateDownloadWithData: selectedDownloadOption === 'with-data',
      mode: mode
    };

    memberServices.updateQaSpecTemplateSettings(params)
      .then(res => {
        if (res?.isSuccess) {
          setIsEditMode(false);
          // setSelectedDownloadOption(null);
          // setSelectedUploadOption(null);

          // fetch from api
          fetchQaSpecSettings();
          CustomNotification.success('Visibility option saved');
        } else {
          CustomNotification.error(res?.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        CustomNotification.error('Update failed, please try again');
      }).finally(() => {
        setLoading(false);
        setIsEditMode(false);
      });
  };

  const isSaveDisabled = selectedDownloadOption == null || selectedUploadOption == null;

  return (
    <Row className='member-tag-restriction system__partial'>
      <Col span={24} className='system__partial'>
        <Title className='member-tag-restriction__title' level={4}>
          <FormattedMessage {...Messages.qaSpecTemplateTitle} />
        </Title>
        {hasPermissionEdit && (
          <Space
            size={4}
            className={{
              'system__partial__edit-actions': true,
              'system__partial__edit-actions--editing': isEditMode,
            }}
          >
            {isEditMode ? (
              <>
                <FormSaveButton 
                  onClick={handleSave} 
                  className='save-btn'
                  title={'Please select values for QA spec template download and upload to proceed ahead'}
                  disabled={isSaveDisabled} 
                />
                <FormCancelButton onClick={handleCancel} />
              </>
            ) : (
              <EditButton onClick={handleEdit} />
            )}
          </Space>
        )}
      </Col>

      <Divider className='member-tag-restriction__divider' />

      {hasPermissionEdit && (
        <Row className='member-tag-restriction__row' gutter={[8, 0]}>
          <Col className='member-tag-restriction__header'>
            <Typography.Text ellipsis={true} strong>
              <FormattedMessage {...Messages.qaSpecTemplateVisibility} />:
            </Typography.Text>
          </Col>
          <Col>
            <Switch
              checked={checkedQaSpecVisibility}
              onChange={onSwitchQaSpecVisibility}
              disabled={!isEditMode}
            />
          </Col>
        </Row>
      )}

      {hasPermissionEdit && checkedQaSpecVisibility && (
        <div className='member-qa-spec-template-management__options'>
          <Row className='member-tag-restriction__row' gutter={[8, 0]}>
            <Col className='member-tag-restriction__header'>
              <Typography.Text ellipsis={true} strong>
                QA Spec Template Download:
              </Typography.Text>
            </Col>
            <Col>
              <Radio.Group
                value={selectedDownloadOption}
                onChange={onDownloadOptionChange}
                disabled={!isEditMode}
              >
                <Radio value="with-data" style={{ display: 'block' }}>With data</Radio>
                <Radio value="without-data" style={{ display: 'block' }}>Without Data</Radio>
              </Radio.Group>
            </Col>
          </Row>

          <Row className='member-tag-restriction__row' gutter={[8, 0]}>
            <Col className='member-tag-restriction__header'>
              <Typography.Text ellipsis={true} strong>
                QA Spec Template Upload:
              </Typography.Text>
            </Col>
            <Col>
              <Radio.Group
                value={selectedUploadOption}
                onChange={onUploadOptionChange}
                disabled={!isEditMode}
              >
                <Radio value="overwrite-data" style={{ display: 'block' }}>Overwrite all data</Radio>
                <Radio value="update-data" style={{ display: 'block' }}>Update only changed data</Radio>
              </Radio.Group>
            </Col>
          </Row>
        </div>
      )}
    </Row>
  );
}

QaSpecTemplateManagementSupplier.propTypes = {
  memberInfo: PropTypes.object,
  onSettingsChange: PropTypes.func,
  initialSettings: PropTypes.shape({
    isQASpecTemplateVisibility: PropTypes.bool,
    isQASpecTemplateDownloadWithData: PropTypes.bool,
    isQASpecTemplateUploadOverrideData: PropTypes.bool,
  }),
};

export default QaSpecTemplateManagementSupplier;
